export function infomodalRender() { return `<div class="modal">
    <div
        class="modal-content info-modal-view"
        role="alertdialog"
        aria-label="modal"
    >
        <div class="modal-body" id="modal-body">
        </div>
        <div class="modal-footer">
            <button class="modal-button" style="${ this.__$objToStyleMap(this.btnStyles) }" ld--elist="click" ld-on-click="onOkClick">${ this.closeButtonText }</button>
        </div>
    </div>
</div>` }